import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAdmin, RequireAuth } from './components/Guards';
import { useAuth } from './auth/AuthContext';

import { LandingPage } from './pages/Landing';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { VerifyEmailPage } from './pages/VerifyEmail';
import { DashboardPage } from './pages/Dashboard';
import { NewInstancePage } from './pages/NewInstance';
import { InstanceSettingsPage } from './pages/InstanceSettings';
import { AccountPage } from './pages/Account';
import { AdminPage } from './pages/admin/Admin';
import { AdminDockerPage } from './pages/admin/Docker';
import { DockerExecPage } from './pages/admin/DockerExec';
import { AdminCaddyPage } from './pages/admin/Caddy';
import { AdminServicesPage } from './pages/admin/Services';
import { AdminSecurityPage } from './pages/admin/Security';

function Home() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : <LandingPage />;
}

export function App() {
  return (
    <Routes>
      {/* The exec terminal is full-bleed, so it sits outside the chrome. */}
      <Route
        path="/admin/docker/containers/:id/exec"
        element={<RequireAdmin><DockerExecPage /></RequireAdmin>}
      />

      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />

        <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
        <Route path="/dashboard/new" element={<RequireAuth><NewInstancePage /></RequireAuth>} />
        <Route path="/dashboard/instances/:id" element={<RequireAuth><InstanceSettingsPage /></RequireAuth>} />
        <Route path="/account" element={<RequireAuth><AccountPage /></RequireAuth>} />

        <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        <Route path="/admin/docker" element={<RequireAdmin><AdminDockerPage /></RequireAdmin>} />
        <Route path="/admin/caddy" element={<RequireAdmin><AdminCaddyPage /></RequireAdmin>} />
        <Route path="/admin/services" element={<RequireAdmin><AdminServicesPage /></RequireAdmin>} />
        <Route path="/admin/security" element={<RequireAdmin><AdminSecurityPage /></RequireAdmin>} />

        <Route path="*" element={<p className="muted">Page not found.</p>} />
      </Route>
    </Routes>
  );
}
